import api from '../api';

export interface AcessoCandidatoConfiguracao {
  id: string;
  janelaLiberacaoHoras: number;
  envioFormularioRecursoPorEmail: boolean;
  validacaoPorHistoricoHabilitada: boolean;
  atualizadoEm: string;
}

export interface AcessoCandidatoConfiguracaoRequest {
  janelaLiberacaoHoras: number;
  envioFormularioRecursoPorEmail: boolean;
  validacaoPorHistoricoHabilitada: boolean;
}

export default class AcessoCandidatoConfiguracaoViewModel {
  static async buscar(): Promise<AcessoCandidatoConfiguracao | null> {
    const response = await api.get<AcessoCandidatoConfiguracao>('/configuracoes/acesso-candidato', {
      validateStatus: (status) => status === 200 || status === 204,
    });

    if (response.status === 204) {
      return null;
    }
    return response.data;
  }

  static async salvar(payload: AcessoCandidatoConfiguracaoRequest): Promise<AcessoCandidatoConfiguracao> {
    const response = await api.put<AcessoCandidatoConfiguracao>('/configuracoes/acesso-candidato', payload);
    return response.data;
  }
}
